import React from 'react';
import PlayerTable from '../common/PlayerTable';

const COLS = [
  { key: 'rank', label: '#', width: 'w-8' },
  { key: 'player', label: 'Player' },
  { key: 'team', label: 'Team', muted: true },
  { key: 'yellowCards', label: 'Y', align: 'right', width: 'w-10', bold: true },
  { key: 'redCards', label: 'R', align: 'right', width: 'w-10' },
];

export default function Discipline({ discipline = [], ...rest }) {
  return (
    <PlayerTable
      {...rest}
      subtitle="Cards"
      rows={discipline}
      columns={COLS}
      emptyMessage="No card data for this competition."
    />
  );
}
